module.exports = __webpack_public_path__ + "8eff2b71aaa6569c2008e6e85de2ee43.png";